export const today = new Date();
export const threeDaysAgo = new Date(new Date().setDate(today.getDate() - 3));
